<template>
    <div v-bind="$attrs" v-on="$listeners" class="dynamic-filters gap-10 align-center">
        <slot></slot>
    </div>
</template>
<script>
  export default {
    props: [],
    data() {
      return {
      };
    },
  };
</script>
